import { BASE_PLAN_SUB_TYPES } from '@/common/constants';
import { flowTypes } from '@/common/service/page-config';

export const MIGRATE_FLOW_TYPES = {
    pro2bundle: 'pro2bundle',
    pro2biz: 'pro2biz',
    biz2bundle: 'biz2bundle',
    biz2pro: 'biz2pro',
    bundle2biz: 'bundle2biz',
    bundle2pro: 'bundle2pro',
}

export const UPGRADE_TYPES = [MIGRATE_FLOW_TYPES.pro2bundle, MIGRATE_FLOW_TYPES.pro2biz, MIGRATE_FLOW_TYPES.biz2bundle];
export const DOWNGRADE_TYPES = [MIGRATE_FLOW_TYPES.biz2pro, MIGRATE_FLOW_TYPES.bundle2biz, MIGRATE_FLOW_TYPES.bundle2pro];

export const MIGRATE_FLOW_TYPES_CONFIG = {
    [BASE_PLAN_SUB_TYPES.PRO]: {
        [BASE_PLAN_SUB_TYPES.PRO]: {
            [BASE_PLAN_SUB_TYPES.BIZ]: 'bizBack2pro',
            [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 'bundleBack2pro', // unscope
        },
        [BASE_PLAN_SUB_TYPES.BIZ]: {
            [BASE_PLAN_SUB_TYPES.PRO]: 'pro2biz',
            [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 'pro2biz',  // unscope
        },
        [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 'pro2bundle',
    },
    [BASE_PLAN_SUB_TYPES.BIZ]: {
        [BASE_PLAN_SUB_TYPES.PRO]: 'biz2pro',
        [BASE_PLAN_SUB_TYPES.BIZ]: {
            [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 'bundleBack2biz',
            [BASE_PLAN_SUB_TYPES.PRO]: 'proBack2biz'
        },
        [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: 'biz2bundle',
    },
    [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: {
        [BASE_PLAN_SUB_TYPES.PRO]: 'bundle2pro', // unscope
        [BASE_PLAN_SUB_TYPES.BIZ]: 'bundle2biz',
        [BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS]: {
            [BASE_PLAN_SUB_TYPES.PRO]: 'proBack2bundle', // unscope
            [BASE_PLAN_SUB_TYPES.BIZ]: 'bizBack2bundle'
        }
    },
};

export const migrationPlanTypes = ({originEditPlanCategory, currentEditPlanCategory, nextEditPlanCategory}) => {
    const currentPlan = MIGRATE_FLOW_TYPES_CONFIG[originEditPlanCategory];
    if (typeof currentPlan[nextEditPlanCategory] === 'string') {
        return currentPlan[nextEditPlanCategory];
    }
    return currentPlan[nextEditPlanCategory]?.[currentEditPlanCategory];
}

export const getMigrateFlowType = (type) => {
    if (UPGRADE_TYPES.includes(type)) return flowTypes.upgrade;
    if (DOWNGRADE_TYPES.includes(type)) return flowTypes.downgrade;
    return '';
};
